export const PLATFORM_TRAINING_START_EVENT = 'platform-training:start'
export const PLATFORM_TRAINING_STEP_EVENT = 'platform-training:step'
export const PLATFORM_TRAINING_BANNER_STORAGE_KEY = 'platformTrainingBannerClosedByUser'
export const PLATFORM_TRAINING_STATE_STORAGE_KEY = 'platformTrainingState'
// Обучение временно отключено, но реализация сохранена для последующего включения.
export const PLATFORM_TRAINING_ENABLED = false

export const PLATFORM_TRAINING_STEPS = {
  SIDEBAR: 'sidebar',
  ADD_STUDENT: 'add-student',
  STUDENT_IDENTITY: 'student-identity',
  STUDENT_COURSE: 'student-course',
  STUDENT_TARIFF: 'student-tariff',
  STUDENT_TEACHER: 'student-teacher',
  STUDENT_DURATION: 'student-duration',
  STUDENT_LESSON_LINK: 'student-lesson-link',
  STUDENT_COST: 'student-cost',
  STUDENT_PAYMENT: 'student-payment',
  STUDENT_PAYMENT_METHOD: 'student-payment-method',
  STUDENT_SCHEDULE: 'student-schedule',
  STUDENT_PASSWORD: 'student-password',
  STUDENT_SAVE: 'student-save',
  CREATED_STUDENT: 'created-student',
}

const getClosedBannerUsers = () => {
  try {
    return JSON.parse(localStorage.getItem(PLATFORM_TRAINING_BANNER_STORAGE_KEY) ?? '{}')
  } catch (_) {
    return {}
  }
}

export const isPlatformTrainingBannerClosed = (userId) => (
  !!userId && getClosedBannerUsers()[userId] === true
)

export const closePlatformTrainingBanner = (userId) => {
  if (!userId) return

  localStorage.setItem(
    PLATFORM_TRAINING_BANNER_STORAGE_KEY,
    JSON.stringify({ ...getClosedBannerUsers(), [userId]: true }),
  )
}

export const getPlatformTrainingState = () => {
  try {
    return JSON.parse(sessionStorage.getItem(PLATFORM_TRAINING_STATE_STORAGE_KEY) ?? 'null')
  } catch (_) {
    return null
  }
}

export const isPlatformTrainingActive = () => (
  PLATFORM_TRAINING_ENABLED && getPlatformTrainingState()?.active === true
)

export const setPlatformTrainingStep = (step, details = {}) => {
  const previousState = getPlatformTrainingState() ?? {}
  const nextState = {
    ...previousState,
    ...details,
    active: true,
    step,
  }

  sessionStorage.setItem(
    PLATFORM_TRAINING_STATE_STORAGE_KEY,
    JSON.stringify(nextState),
  )
  window.dispatchEvent(new CustomEvent(PLATFORM_TRAINING_STEP_EVENT, {
    detail: nextState,
  }))

  return nextState
}

export const advancePlatformTrainingStep = (currentStep, nextStep, details = {}) => {
  const state = getPlatformTrainingState()
  if (!state?.active || state.step !== currentStep) return false

  setPlatformTrainingStep(nextStep, details)
  return true
}

export const finishPlatformTraining = () => {
  sessionStorage.removeItem(PLATFORM_TRAINING_STATE_STORAGE_KEY)
}

export const dispatchPlatformTrainingStart = () => {
  const state = setPlatformTrainingStep(PLATFORM_TRAINING_STEPS.SIDEBAR)
  window.dispatchEvent(new CustomEvent(PLATFORM_TRAINING_START_EVENT, {
    detail: state,
  }))
}
